import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'

//  local components
import LoadingAnimation from './tribeConnections/components/loadingAnimation'
import SearchBar from './components/support-materials/searchBar'
import ResultsContainer from './components/support-materials/resultsContainer'
/**
 * Please Note: This react app is heavily using a javascript variable that is already set in site.php
 * called supportMaterialsData. This variable has all the data for the course categories
 * and related courses
 */
function SupportMaterials(props) {
    //**** URL PARAMETERS CODE */
    // the following code block it all dealing with url query parameters
    // that might be set when the page loads.
    // if passed a url query parameter to search for, set it
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // sm-search - query string to search for
    const searchString = urlParams.get('sm-search');

    var parentCategory = false;
    var subCategory = false;
    const subCatParam = parseInt(urlParams.get('sub-cat'));
    const parentCatParam = parseInt(urlParams.get('cat'));
    const rec_phrases = JSON.parse(props.rec_phrases_json);
    const languages = supportMaterialsData.languages;
    const englishId = languages.find(lang => lang.label === "English")?.id;

    const doesSubCategoryExist = (subCatSearchId) => {
        for (const category of supportMaterialsData.categories) {
            for (const subcategory of category.subCategories) {
              if (subcategory.id == subCatSearchId) {
                parentCategory = category;
                subCategory = subcategory;
                return true;
              }
            }
          }
          return false;
    }

    if(!doesSubCategoryExist(subCatParam)){
        for (const category of supportMaterialsData.categories) {
            if(category.id == parentCatParam){
                parentCategory = category;
            }
        }
    }
    //** END OF URL PARAMETERS CODE */


    //  all-component state
    const [initialized, setInitialized] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [failGracefully, setFailGracefully] = React.useState(false)
    const [showAccessibleMaterials, setShowAccessibleMaterials] = React.useState(false)
    const [selectedCategory, setSelectedCategory] = React.useState(parentCategory ? parentCategory : null)
    const [selectedSubCategory, setSelectedSubCategory] = React.useState(subCategory ? subCategory : null)
    const [selectedThirdCategory, setSelectedThirdCategory] = React.useState(null)
    const [selectedRelatedCourse, setSelectedRelatedCourse] = React.useState(null)
    const [selectedCategoryKey, setSelectedCategoryKey] = React.useState(parentCategory ? parentCategory.id : "key")
    const [selectedSubCategoryKey, setSelectedSubCategoryKey] = React.useState(subCategory ? subCategory.id : "key");
    const [selectedThirdCategoryKey, setSelectedThirdCategoryKey] = React.useState("any");
    const [selectedRelatedCourseKey, setSelectedRelatedCourseKey] = React.useState("any")
    const [selectedLanguage, setSelectedLanguage] = React.useState(englishId ? englishId : "any");
    const [categories, setCategories] = React.useState(supportMaterialsData.categories)
    const [relatedCourses, setRelatedCourses] = React.useState(supportMaterialsData.relatedCourses)
    const [searchPhrase, setSearchPhrase] = React.useState(searchString ? searchString : "")
    const [searchPage, setSearchPage] = React.useState(1)
    const [firstPage, setFirstPage] = React.useState(1)
    const [lastPage, setLastPage] = React.useState(1)
    const [results, setResults] = React.useState([])
    const [totalFound, setTotalFound] = React.useState(0)
    const [rerunSearchToggle, setRerunSearchToggle] = React.useState(false)

    //  non-stateful vars
    const resultsPerPage = 50;

    //  run when component mounted
    useEffect(() => {
        runSearch()
    }, [
        rerunSearchToggle, selectedLanguage
    ])

    const runSearch = function() {
        setLoading(true)
        setFailGracefully(false)

        //  get selected category id
        const selectedCategoryId = selectedCategory?.id;

        //  get selected sub category id
        const selectedSubCategoryId = selectedSubCategory?.id;

        //  get related course id
        const selectedRelatedCourseId = selectedRelatedCourse?.id;
  
        // /wp-admin/admin-ajax.php
        axios.get( urls.ajax, {
            withCredentials: true,
            headers: {},
            params: {
                action: 'support_materials_results',
                nonce: props.nonce,
                searchPhrase: searchPhrase,
                selectedCategoryId: selectedCategoryId,
                selectedSubCategoryId: selectedSubCategoryId,
                selectedRelatedCourse: selectedRelatedCourseId,
                selectedLanguage: selectedLanguage,
                showAccessibleMaterials: showAccessibleMaterials,
                resultsPerPage: resultsPerPage,
                page: searchPage
            }
        })
        .then(res => {
            if(res.data.success === true) {
                setResults(res.data.data['support_materials'])
                setTotalFound(res.data.data['total_found'])
                setLastPage(Math.ceil(res.data.data['total_found'] / resultsPerPage))
            }
            setLoading(false)
            window.scrollTo(0,0)
        })
        .catch(err => {
            if (err.response) {
                console.log('An error occurred while querying support materials: '+err.response)
                setFailGracefully(true)
            }
            setLoading(false)
        });
    }

    const handleSearchPhraseChange = function(searchPhrase) {
        setSelectedCategory(null)
        setSelectedCategoryKey("any")
        setSelectedSubCategory(null)
        setSelectedSubCategoryKey("any")
        setSearchPhrase(searchPhrase)
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleCategoryChange = function(categoryId) {

        //  store 'category' state
        if(categoryId !== "any") {
            let category = categories.find(c => c.id === categoryId)
            setSelectedCategory(category)
        } else {
            setSelectedCategory(null)
        }
        
        setSelectedCategoryKey(categoryId)
        setSelectedSubCategory(null)
        setSelectedSubCategoryKey("any")
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleSubCategoryChange = function(subCategoryId) {

        //  store 'sub category' state
        if(subCategoryId !== "any") {
            let subCategory = selectedCategory.subCategories.find(c => c.id === subCategoryId)
            setSelectedSubCategory(subCategory)
        } else {
            setSelectedSubCategory(null)
        }
        
        setSelectedSubCategoryKey(subCategoryId)
        setSelectedThirdCategory(null)
        setSelectedThirdCategoryKey("any")
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleThirdCategoryChange = function(thirdCategoryId) {

        //  store 'third category' state
        if(thirdCategoryId !== "any") {
            let thirdCategory = selectedSubCategory.children.find(c => c.id === thirdCategoryId)
            setSelectedThirdCategory(thirdCategory)
        } else {
            setSelectedThirdCategory(null)
        }
        
        setSelectedThirdCategoryKey(thirdCategoryId)
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleRelatedCourseChange = function(relatedCourseId) {

        //  store 'related course' state
        if(relatedCourseId !== "any") {
            let relatedCourse = relatedCourses.find(c => c.id === relatedCourseId)
            setSelectedRelatedCourse(relatedCourse)
        } else {
            setSelectedRelatedCourse(null)
        }
        
        setSelectedRelatedCourseKey(relatedCourseId)
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleShowAccessibleMaterialsChange = function(event) {

        //  store 'show accessible materials' state
        let showAccessibleMaterials = event.target.checked
        setShowAccessibleMaterials(showAccessibleMaterials)
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handlePrevPageClick = function(event) {
        if(searchPage > firstPage) {
            setSearchPage(searchPage - 1)
            setRerunSearchToggle(!rerunSearchToggle)
        }
    }

    const handleNextPageClick = function(event) {
        if(searchPage < lastPage) {
            setSearchPage(searchPage + 1)
            setRerunSearchToggle(!rerunSearchToggle)
        }
    }

    const handlePageClick = function(event, page) {
        if(searchPage >= firstPage && searchPage <= lastPage) {
            setSearchPage(page)
            setRerunSearchToggle(!rerunSearchToggle)
        }
    }

    const handleResetFiltersClick = function() {
        setSearchPhrase('')
        setSelectedCategory(null)
        setSelectedSubCategory(null)
        setSelectedThirdCategory(null)
        setSelectedRelatedCourse(null)
        setSelectedCategoryKey("any")
        setSelectedSubCategoryKey("any")
        setSelectedThirdCategoryKey("any")
        setSelectedRelatedCourseKey("any")
        setShowAccessibleMaterials(false)
        setSelectedLanguage(englishId ? englishId : "any")
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleResetSelectedCategoryClick = function() {
        setSelectedCategory(null)
        setSelectedCategoryKey("any")
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleResetSelectedSubCategoryClick = function() {
        setSelectedSubCategory(null)
        setSelectedSubCategoryKey("any")
        setSelectedThirdCategory(null)
        setSelectedThirdCategoryKey("any")
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleResetSelectedThirdCategoryClick = function() {
        setSelectedThirdCategory(null)
        setSelectedThirdCategoryKey("any")
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleResetSelectedRelatedCourseClick = function() {
        setSelectedRelatedCourse(null)
        setSelectedRelatedCourseKey("any")
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }

    const handleRecommendedSearchClick = function(event, phrase) {
        setSearchPhrase(phrase)
        setSearchPage(1)
        setRerunSearchToggle(!rerunSearchToggle)
    }


    return (
        <>
            <h1 className="alignleft">Support Materials</h1>

            <div className="clearfix"></div>
            
            { failGracefully ?

                <div className="messages error">
                    <h4>Sorry...</h4>
                    There was a problem loading connection data. Please try again later.
                </div>

                :
                
                <>
                    { loading === true &&
                        <LoadingAnimation />
                    }
        
                    <SearchBar 
                        loading={loading}
                        results={results}
                        totalFound={totalFound}
                        searchPage={searchPage}
                        searchPhrase={searchPhrase}
                        categories={categories}
                        languages={languages}
                        relatedCourses={relatedCourses}
                        selectedCategory={selectedCategory}
                        selectedSubCategory={selectedSubCategory}
                        selectedThirdCategory={selectedThirdCategory}
                        selectedRelatedCourse={selectedRelatedCourse}
                        showAccessibleMaterials={showAccessibleMaterials}
                        selectedCategoryKey={selectedCategoryKey}
                        selectedSubCategoryKey={selectedSubCategoryKey}
                        selectedThirdCategoryKey={selectedThirdCategoryKey}
                        selectedRelatedCourseKey={selectedRelatedCourseKey}
                        handleResetFiltersClick={handleResetFiltersClick}
                        handleSearchPhraseChange={handleSearchPhraseChange}
                        handleCategoryChange={handleCategoryChange}
                        handleSubCategoryChange={handleSubCategoryChange}
                        handleThirdCategoryChange={handleThirdCategoryChange}
                        handleRelatedCourseChange={handleRelatedCourseChange}
                        handleShowAccessibleMaterialsChange={handleShowAccessibleMaterialsChange}
                        handleResetSelectedCategoryClick={handleResetSelectedCategoryClick}
                        handleResetSelectedSubCategoryClick={handleResetSelectedSubCategoryClick}
                        handleResetSelectedThirdCategoryClick={handleResetSelectedThirdCategoryClick}
                        handleResetSelectedRelatedCourseClick={handleResetSelectedRelatedCourseClick}
                        handleRecommendedSearchClick={handleRecommendedSearchClick}
                        setSelectedLanguage = {setSelectedLanguage}
                        selectedLanguage={selectedLanguage}
                        englishId={englishId ? englishId : "any"}
                        selectedLanguageLabel={languages.find(lang => lang.id === selectedLanguage)?.label}
                        rec_phrases={rec_phrases}
                    />
        
                    <ResultsContainer 
                        results={results}
                        firstPage={firstPage}
                        lastPage={lastPage}
                        searchPage={searchPage}
                        handlePrevPageClick={handlePrevPageClick}
                        handleNextPageClick={handleNextPageClick}
                        handlePageClick={handlePageClick}
                        handleResetFiltersClick={handleResetFiltersClick}
                        handleRecommendedSearchClick={handleRecommendedSearchClick}
                        defaultRestrictedContentMessage={props.default_restricted_content_message}
                    />

                </>
            }

            <div className="clearfix"></div>
        </>
    );
}

const appContainer = document.getElementById('support-materials-root');
if (appContainer !== null) {
    const appElement = <SupportMaterials nonce={appContainer.getAttribute('nonce')} rec_phrases_json={appContainer.getAttribute('rec-phrases-json')} default_restricted_content_message={appContainer.getAttribute('default-restricted-content-message')} />;
    ReactDOM.render(
        appElement,
        appContainer
    );
}